import dt from 'dayjs'
import * as lib from '../lib'
import { IFetchItems, IFetchRevenueSpend, IRevenueSpend } from '../types'

export const listRevenueSpend = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal: AbortSignal,
	token?: string | null
): Promise<IFetchItems<IRevenueSpend>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take
	}
	const uri: string = 'revenue/spend'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal
	}
	const data = await lib.fetching<IFetchItems<IFetchRevenueSpend>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchRevenueSpend): IRevenueSpend => {
			const { at, createdAt, updatedAt, account, agency, ...row } = item
			return {
				...row,
				at: dt(at).toDate(),
				createdAt: dt(createdAt).toDate(),
				updatedAt: dt(updatedAt).toDate(),
				...(!!account && {
					account: {
						...account,
						registeredAt: !!account.registeredAt ? dt.utc(account.registeredAt).toDate() : null,
						createdAt: dt.utc(account.createdAt).toDate(),
						updatedAt: dt.utc(account.updatedAt).toDate(),
						deletedAt: !!account.deletedAt ? dt.utc(account.deletedAt).toDate() : null,
						role: !account?.role ? null : {
							...account.role,
							createdAt: dt.utc(account.role.createdAt).toDate(),
							updatedAt: dt.utc(account.role.updatedAt).toDate()
						},
						auth: !account?.auth ? null : {
							...account.auth,
							updatedAt: dt.utc(account.auth.updatedAt).toDate()
						}
					}
				}),
				...(!!agency && {
					agency: {
						...agency,
						createdAt: dt.utc(agency.createdAt).toDate(),
						updatedAt: dt.utc(agency.updatedAt).toDate(),
						percents: agency.percents?.map(item => ({
							...item,
							at: dt(item.at).toDate(),
							nextAt: item.nextAt ? dt(item.nextAt).toDate() : null
						})) ?? []
					}
				})
			}
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0
	}
}
